import { render, staticRenderFns } from "./tableReports.vue?vue&type=template&id=71a5c6a9&"
import script from "./tableReports.vue?vue&type=script&lang=js&"
export * from "./tableReports.vue?vue&type=script&lang=js&"
import style0 from "./tableReports.vue?vue&type=style&index=0&id=71a5c6a9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports